'use client';

import React from 'react';
import { useSession, signIn } from 'next-auth/react';
import { PiUserCircleLight } from 'react-icons/pi';
import { IconButton } from '@/components/ui/button';
import { UserMenu } from './user-menu';

type MobileUserButtonProps = {
  loginAriaLabel?: string;
  manageAccountLabel?: string;
  myProgressLabel?: string;
  signOutLabel?: string;
};

export const MobileUserButton = ({
  loginAriaLabel = 'Login',
  manageAccountLabel,
  myProgressLabel,
  signOutLabel,
}: MobileUserButtonProps) => {
  const { data: session, status } = useSession();
  const isLoading = status === 'loading';
  const isLoggedIn = !!session?.user;

  if (isLoading) {
    return null;
  }

  if (isLoggedIn) {
    return (
      <UserMenu
        manageAccountLabel={manageAccountLabel}
        myProgressLabel={myProgressLabel}
        signOutLabel={signOutLabel}
      />
    );
  }

  return (
    <IconButton
      onClick={() => signIn()}
      aria-label={loginAriaLabel}
    >
      <PiUserCircleLight size={28} />
    </IconButton>
  );
};
